import React, { useState } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { Button, FlexRow } from "@ufginsurance/ui-kit";
import { usePolicyChangesContext } from "../context";
import * as routes from "../../../constants/routes";
import QuoteUnderwriterReviewErrorModal from "./QuoteUnderwriterReviewErrorModal";

const Step1DriverFooter = ({ history }) => {
  const { policyData } = usePolicyChangesContext();
  const [showUnderwriterReviewErrorModal, setShowUnderwriterReviewErrorModal] =
    useState(false);

  const submitBtnText = "Continue to Change Summary";

  const onSubmit = () => {
    const { policy_number, job_id } = policyData?.policyInfo;
    history.push(
      `${routes.POLICY_CHANGES}/${policy_number}/jobId/${job_id}/step/2`
    );
  };

  return (
    <>
      <FlexRow align="right">
        {policyData?.policyInfo && (
          <Button
            id="driverChangeSubmit"
            onClick={onSubmit}
            variant="primary"
            spinner={false}
            disabled={false}
          >
            {submitBtnText}
          </Button>
        )}
      </FlexRow>
      <QuoteUnderwriterReviewErrorModal
        showUnderwriterReviewErrorModal={showUnderwriterReviewErrorModal}
        setShowUnderwriterReviewErrorModal={setShowUnderwriterReviewErrorModal}
        policyNumber={policyData?.policyInfo?.policy_number}
      />
    </>
  );
};

Step1DriverFooter.propTypes = {
  history: PropTypes.object
};

export default withRouter(Step1DriverFooter);
